import React, { useContext, useEffect } from 'react';
import useDataApi from '../hooks/useDataApi';
import usePrevious from '../hooks/usePrevious';
import { __RouterContext as RouterContext } from 'react-router';

const useLocation = () => {
  const { location } = useContext(RouterContext);
  return location;
};
/**
 * Contexto utilizado para contener el estado de la página que se está viendo
 * y la página de la que se está recibiendo información
 */
const PageContext = React.createContext();
const SetPageContext = React.createContext();
const ParentLevelContext = React.createContext();
const MesaContext = React.createContext();

export function PageProvider({ children }) {
  const [page, setPage] = useDataApi({});
  const prevPage = usePrevious(page);
  useEffect(() => {
    if (prevPage !== page) {
      window.scrollTo(0, 0);
    }
  });

  //descargar json de datos de nuevo si hacemos clic para ir a la misma página en la que estamos
  const location = useLocation();
  const prevKey = usePrevious(location.key);
  const prevPathname = usePrevious(location.pathname);
  const prevSearch = usePrevious(location.search);
  useEffect(() => {
    //esto caracteriza a hacer un push en history de la misma pagina (clicar en un enlace a la
    //página en la que ya estamos)
    if (
      location.pathname === prevPathname &&
      location.search === prevSearch &&
      page.urlInfo === page.requestedUrlInfo &&
      location.key !== prevKey
    ) {
      setPage(page.url, { ...page.urlInfo });
    }
  }, [
    prevKey,
    location.key,
    page.url,
    page.urlInfo,
    page.requestedUrlInfo,
    setPage,
    location.pathname,
    prevPathname,
    location.search,
    prevSearch,
  ]);

  return (
    <PageContext.Provider value={page}>
      <SetPageContext.Provider value={setPage}>
        <ParentLevelContext.Provider value={page?.urlInfo?.parentLevel}>
          <MesaContext.Provider value={page?.urlInfo?.mesa}>
            {children}
          </MesaContext.Provider>
        </ParentLevelContext.Provider>
      </SetPageContext.Provider>
    </PageContext.Provider>
  );
}

export function usePage() {
  const context = useContext(PageContext);
  return context;
}

export function useSetPage() {
  const context = useContext(SetPageContext);
  return context;
}

export function useParentLevel() {
  const context = useContext(ParentLevelContext);
  return context;
}
export function useMesa() {
  const context = useContext(MesaContext);
  return context;
}
